import React from 'react';
import { Image } from 'antd';
import { Download } from 'lucide-react';

interface ImagePreviewProps {
    src: string;
    alt?: string;
    visible: boolean;
    onVisibleChange: (visible: boolean) => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
    src,
    alt = 'Image Preview',
    visible,
    onVisibleChange
}) => {
    const handleDownload = async () => {
        if (!src) return;
        try {
            const response = await fetch(src);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = alt ? `${alt.toLowerCase().replace(/\s+/g, '_')}_profile.jpg` : 'student_profile.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            // Fallback for CORS blockages: open direct link in a new tab
            const link = document.createElement('a');
            link.href = src;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.download = alt || 'student_profile.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div style={{ display: 'none' }}>
            <Image
                src={src}
                alt={alt}
                preview={{
                    visible,
                    src,
                    onVisibleChange,
                    scaleStep: 0.5,
                    toolbarRender: (originalNode) => (
                        <div className="flex items-center gap-3 select-none">
                            {originalNode}
                            <button
                                type="button"
                                onClick={handleDownload}
                                className="flex items-center justify-center w-9 h-9 rounded-full bg-black/40 hover:bg-black/60 text-white hover:text-emerald-400 active:scale-95 transition-all duration-200 focus:outline-none"
                                title="Download Profile Image"
                                style={{ pointerEvents: 'auto' }}
                            >
                                <Download className="w-4.5 h-4.5" />
                            </button>
                        </div>
                    )
                }}
            />
        </div>
    );
};

export default ImagePreview;
